import { render, staticRenderFns } from "./all_by_algorithm_goods_list.mpx?vue&type=template&id=4995c452&scoped=true&component=true&componentId=all_by_algorithm_goods_list1db71026"
import script from "./all_by_algorithm_goods_list.mpx?vue&type=script&lang=js&component=true&componentId=all_by_algorithm_goods_list1db71026"
export * from "./all_by_algorithm_goods_list.mpx?vue&type=script&lang=js&component=true&componentId=all_by_algorithm_goods_list1db71026"
import style0 from "./all_by_algorithm_goods_list.mpx?vue&type=style&index=0&id=4995c452&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m1db71026%22%7D&component=true&componentId=all_by_algorithm_goods_list1db71026"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4995c452",
  null
  
)

export default component.exports